import React, { Component } from "react";
import PropTypes from "prop-types";
import PodcastsView from "../components/Views/MyPodcastsView";
import { connect } from "react-redux";
import { fetchPodcasts } from "../store/actions/podcastsActions";
import { MY_PODCASTS } from "../store/actions/types";

class MyPodcasts extends Component {
  constructor (props) {
    super(props);
    this.state = {
      height: window.innerHeight,
      minData: 6
    };
    this.handleScroll = this.handleScroll.bind(this);
  }
  handleScroll() {
    const windowHeight =
      "innerHeight" in window
        ? window.innerHeight
        : document.documentElement.offsetHeight;
    const body = document.body;
    const html = document.documentElement;
    const docHeight = Math.max(
      body.scrollHeight,
      body.offsetHeight,
      html.clientHeight,
      html.scrollHeight,
      html.offsetHeight
    );
    const windowBottom = Math.round(windowHeight + window.pageYOffset);
    if (windowBottom >= docHeight) {
      this.setState({
        minData: this.state.minData + 6
      });
      this.fetchData();
    }
  }

  componentDidMount() {
    // console.log("user mypodcasts: ", this.props.userdata);
    window.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  componentWillMount = () => {
    this.fetchData();
  };

  fetchData = () => {
    var params = {
      type: MY_PODCASTS,
      companyID: this.props.userdata.companyID,
      orderChild: "postOwner",
      equalTo: this.props.userdata.userID,
      minData: this.state.minData
    };
    this.props.fetchPodcasts(params);
  };

  render() {
    const { podcasts, userdata } = this.props;
    return (
      <div>
        {userdata && podcasts ? (
          <React.Fragment>
            <PodcastsView podcasts={podcasts} userdata={this.props.userdata} />
          </React.Fragment>
        ) : null}
      </div>
    );
  }
}

MyPodcasts.propTypes = {
  fetchPodcasts: PropTypes.func.isRequired,
  podcasts: PropTypes.array
};

const mapStateToProps = state => {
  return {
    podcasts: state.podcasts.mypodcasts,
    userdata: state.userDialog.userDetails[0]
  };
};

export default connect(
  mapStateToProps,
  { fetchPodcasts }
)(MyPodcasts);
